import {
  FormControl,
  FormControlProps,
  FormErrorMessage,
  FormLabel,
  HStack,
  Icon,
  RedAsterix,
  Text,
  Tooltip,
} from '@wegroup/design-system';
import React from 'react';
import { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Props {
  error?: FieldError;
  label: string;
  isRequired?: boolean;
  tooltip?: string;
}

const PartyCreationFormInput: React.FC<
  React.PropsWithChildren<Props & FormControlProps>
> = ({ error, tooltip, label, children, isRequired, ...props }) => {
  const { t } = useTranslation();

  return (
    <FormControl isInvalid={!!error} {...props}>
      <FormLabel>
        <Tooltip label={tooltip} isDisabled={!tooltip} shouldWrapChildren>
          <HStack>
            <Text>
              {label}
              {isRequired && (
                <>
                  {' '}
                  <RedAsterix />
                </>
              )}
            </Text>
            {tooltip && <Icon name="GeneralStatusInfoOutline" boxSize="14px" />}
          </HStack>
        </Tooltip>
      </FormLabel>
      {children}
      {error?.message && (
        <FormErrorMessage>{t(error?.message)}</FormErrorMessage>
      )}
    </FormControl>
  );
};

export default PartyCreationFormInput;
